import React from 'react';

import { FormattedMessage } from '../../util/reactIntl';
import { orderImagesByCoverPhoto } from '../../util/listingImages';
import { ResponsiveImage, Modal } from '../../components';

import ImageCarousel from './ImageCarousel/ImageCarousel';
import ActionBarMaybe from './ActionBarMaybe';

import css from './ListingPage.module.css';

const SectionHero = props => {
  const {
    title,
    listing,
    isOwnListing,
    editParams,
    handleViewPhotosClick,
    imageCarouselOpen,
    onImageCarouselClose,
    onManageDisableScrolling,
    noPayoutDetailsSetWithOwnListing,
  } = props;

  const publicData = listing.attributes?.publicData;
  const orderedImages = orderImagesByCoverPhoto(listing.images, publicData);
  const hasImages = orderedImages.length > 0;
  const firstImage = orderedImages[0] || null;
  const variants = firstImage
    ? Object.keys(firstImage?.attributes?.variants).filter(k =>
      k.startsWith('scaled')
    )
    : [];

  const viewPhotosButton = hasImages ? (
    <button className={css.viewPhotos} onClick={handleViewPhotosClick}>
      <FormattedMessage
        id="ListingPage.viewImagesButton"
        values={{ count: listing.images.length }}
      />
    </button>
  ) : null;

  return (
    <section className={css.sectionHero} data-testid="hero">
      <div
        className={css.imageWrapperForSectionHero}
        onClick={handleViewPhotosClick}
      >
        {listing.id && isOwnListing ? (
          <div
            onClick={e => e.stopPropagation()}
            className={css.actionBarContainerForHeroLayout}
          >
            {noPayoutDetailsSetWithOwnListing ? (
              <ActionBarMaybe
                className={css.actionBarForHeroLayout}
                isOwnListing={isOwnListing}
                listing={listing}
                showNoPayoutDetailsSet={noPayoutDetailsSetWithOwnListing}
              />
            ) : null}

            <ActionBarMaybe
              className={css.actionBarForHeroLayout}
              isOwnListing={isOwnListing}
              listing={listing}
              editParams={editParams}
            />
          </div>
        ) : null}

        <ResponsiveImage
          rootClassName={css.rootForImage}
          alt={title}
          image={firstImage}
          variants={variants}
          sizes="100vw"
          loading="eager"
          decoding="sync"
          fetchpriority="high"
        />
        {viewPhotosButton}
      </div>
      <Modal
        id="ListingPage.imageCarousel"
        scrollLayerClassName={css.carouselModalScrollLayer}
        containerClassName={css.carouselModalContainer}
        lightCloseButton
        isOpen={imageCarouselOpen}
        onClose={onImageCarouselClose}
        usePortal
        onManageDisableScrolling={onManageDisableScrolling}
      >
        <ImageCarousel
          images={orderedImages}
          imageVariants={[
            'scaled-small',
            'scaled-medium',
            'scaled-large',
            'scaled-xlarge',
          ]}
        />
      </Modal>
    </section>
  );
};

export default SectionHero;
